var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paginationData.total > 0 && _vm.paginationData.total > _vm.paginationData.page * _vm.paginationData.size)?_c('infinite-loading',{attrs:{"spinner":"circles"},on:{"infinite":_vm.loadMore}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }